import type { IndexRouteObject, RouteObject } from "react-router-dom";
import App from "./App";
import { environment } from "./environment";
import {
  Applications,
  DeviceActivity,
  Groups,
  LinkedAccounts,
  PersonalInfo,
  Resources,
  SigningIn,
  // Organizations,
  ContentComponent,
  Oid4Vci
} from "@keycloak/keycloak-account-ui";
import { Avatar } from "./Avatar.tsx";

export const DeviceActivityRoute: RouteObject = {
  path: "account-security/device-activity",
  element: <DeviceActivity />,
};

export const LinkedAccountsRoute: RouteObject = {
  path: "account-security/linked-accounts",
  element: <LinkedAccounts />,
};

export const SigningInRoute: RouteObject = {
  path: "account-security/signing-in",
  element: <SigningIn />,
};

export const ApplicationsRoute: RouteObject = {
  path: "applications",
  element: <Applications />,
};

export const GroupsRoute: RouteObject = {
  path: "groups",
  element: <Groups />,
};

export const ResourcesRoute: RouteObject = {
  path: "resources",
  element: <Resources />,
};

export const ContentRoute: RouteObject = {
  path: "content/:componentId",
  element: <ContentComponent />,
};

export const PersonalInfoRoute: IndexRouteObject = {
  index: true,
  path: "",
  element: <PersonalInfo />,
};

// FIXME account-ui 26.4.1 is missing this export. Add on next update, see https://github.com/keycloak/keycloak/issues/43512
// export const OrganizationsRoute: RouteObject = {
//   path: "organizations",
//   element: <Organizations />,
// };

export const Oid4VciRoute: RouteObject = {
  path: "oid4vci",
  element: <Oid4Vci />,
};

export const AvatarRoute: RouteObject = {
  path: "avatar",
  element: <Avatar />,
};

export const RootRoute: RouteObject = {
  path: decodeURIComponent(new URL(environment.baseUrl).pathname),
  element: <App />,
  errorElement: <>Error</>,
  children: [
    PersonalInfoRoute,
    DeviceActivityRoute,
    LinkedAccountsRoute,
    SigningInRoute,
    ApplicationsRoute,
    GroupsRoute,
    // OrganizationsRoute,
    ResourcesRoute,
    ContentRoute,
    AvatarRoute,
    ...(environment.features.isOid4VciEnabled ? [Oid4VciRoute] : [])
  ],
};

export const routes: RouteObject[] = [RootRoute];
